import React, { useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../molecules/RoundedModal'
import ErrorBoundary from '../../../molecules/ErrorBoundary'
import PasswordForm from './PasswordForm'

const ChangePasswordDialog = React.forwardRef(function ChangePasswordDialog ({ authenticator, enrollment }, ref) {
  const [open, setOpen] = useState(false)

  useImperativeHandle(ref, () => ({
    open: () => setOpen(true)
  }), [setOpen])

  return (
    <RoundedModal
      size='xmedium'
      title='Change your password'
      open={open}
      onClose={() => setOpen(false)}
    >
      <ErrorBoundary name='Change Password Form'>
        <PasswordForm onClose={() => setOpen(false)} />
      </ErrorBoundary>
    </RoundedModal>
  )
})

ChangePasswordDialog.propTypes = {
  authenticator: PropTypes.shape({
    id: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
    enrollable: PropTypes.bool
  }),
  enrollment: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    created: PropTypes.string
  })
}

export default ChangePasswordDialog
